import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import GlobalStyles from './styles/GlobalStyles';
import { Layout } from './components/layout';
import {
  HomePage,
  BlogListPage,
  BlogDetailPage,
  CategoriesPage,
  AboutPage,
  DriverApplicationPage,
  HowToUsePage,
  SozlesmelerPage,
} from './pages';
import {
  CekiciGuidePage,
  VincGuidePage,
  NakliyeGuidePage,
  YolYardimGuidePage,
  ServisGuidePage,
  VipTasimaGuidePage,
  SurucuGuidePage,
} from './pages/how-to-use';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <GlobalStyles />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/kategoriler" element={<CategoriesPage />} />
            <Route path="/kategori/:slug" element={<BlogListPage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/surucu-basvuru" element={<DriverApplicationPage />} />
            <Route path="/nasil-kullanilir" element={<HowToUsePage />} />
            <Route path="/nasil-kullanilir/cekici" element={<CekiciGuidePage />} />
            <Route path="/nasil-kullanilir/vinc" element={<VincGuidePage />} />
            <Route path="/nasil-kullanilir/nakliye" element={<NakliyeGuidePage />} />
            <Route path="/nasil-kullanilir/yol-yardim" element={<YolYardimGuidePage />} />
            <Route path="/nasil-kullanilir/servis" element={<ServisGuidePage />} />
            <Route path="/nasil-kullanilir/vip-tasima" element={<VipTasimaGuidePage />} />
            <Route path="/nasil-kullanilir/surucu" element={<SurucuGuidePage />} />
            <Route path="/sozlesmeler" element={<SozlesmelerPage />} />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
